import React from 'react';

type Props = {
  fill: string;
};

const ArrowIcon = ({ fill }: Props): React.ReactElement => (
  <svg width="100%" viewBox="0 0 10.01 13.03">
    <path
      style={{ fill }}
      d="M9.77 11.37c-.06-3.4 0-5.5 0-5.5s-.35-.24-.63-4.13c1-.82-.35-2.3-1.35-1.5S5.86 1.78
      4.62 2.78 1.78 5.05.55 5.85a1 1 0 0 0-.1 1.73c2.46 1.9 5.74 2.7 7.8 5.1a1 1 0 0 0 1.52-1.33z"
    />
  </svg>
);

ArrowIcon.defaultProps = {
  fill: '#FFF'
};

export default ArrowIcon;
